import React, { useEffect, useState } from "react";
import * as tenantUserActions from "src/redux/slices/tenantUserSlice";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import { toast } from "react-toastify";
import Button from "../ui/Button";
import Input from "../ui/Input";

const ResetPasswordCard: React.FC = () => {
  const dispatch = useAppDispatch();
  const { changePassword } = useAppSelector((state) => state.tenantUser);
  const { user } = useAppSelector((state) => state.authTenant);

  const [fields, setFields] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  // ✅ Side-effects after password change
  useEffect(() => {
    if (changePassword?.data) {
      toast.success("Password changed successfully");
      dispatch(tenantUserActions.resetChangeTenantUserPassword());
      setFields({ oldPassword: "", newPassword: "", confirmPassword: "" });
    } else if (changePassword?.error) {
      toast.error(`Error: ${changePassword.error}`);
    }
  }, [changePassword]);

  // ✅ Validation before submitting
  const validate = () => {
    const newErrors = { ...errors };
    let valid = true;

    if (!fields.oldPassword.trim()) {
      newErrors.oldPassword = "Old password is required";
      valid = false;
    } else newErrors.oldPassword = "";

    if (!fields.newPassword.trim()) {
      newErrors.newPassword = "New password is required";
      valid = false;
    } else if (fields.newPassword.length < 6) {
      newErrors.newPassword = "Must be at least 6 characters";
      valid = false;
    } else newErrors.newPassword = "";

    if (fields.newPassword !== fields.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
      valid = false;
    } else newErrors.confirmPassword = "";

    setErrors(newErrors);
    return valid;
  };

  // ✅ Handle form submit
  const handleReset = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const payload = {
        oldPassword: fields.oldPassword,
        newPassword: fields.newPassword,
      };
      dispatch(tenantUserActions.changeTenantUserPasswordRequest(payload));
    } catch (error: any) {
      toast.error("Failed to change password");
      console.error(error);
    }
  };

  return (
    <>
      <form className="space-y-4 max-w-md" onSubmit={handleReset}>
        <Input
          label={"Old Password"}
          name="oldPassword"
          type="password"
          placeholder="Enter old password"
          value={fields.oldPassword}
          onChange={(e) =>
            setFields({ ...fields, oldPassword: e.target.value })
          }
          error={!!errors.oldPassword}
          helperText={errors.oldPassword}
        />

        <Input
          label={"New Password"}
          name="oldPassword"
          type="password"
          placeholder="Enter new password"
          value={fields.newPassword}
          onChange={(e) =>
            setFields({ ...fields, newPassword: e.target.value })
          }
          error={!!errors.newPassword}
          helperText={errors.newPassword}
        />

        <Input
          label={"Confirm New Password"}
          name="oldPassword"
          type="password"
          placeholder="Re-enter new password"
          value={fields.confirmPassword}
          onChange={(e) =>
            setFields({ ...fields, confirmPassword: e.target.value })
          }
          error={!!errors.confirmPassword}
          helperText={errors.confirmPassword}
        />

        <div className="flex justify-end space-x-2">
          <Button
            type="button"
            variant="outline"
            onClick={() =>
              setFields({
                oldPassword: "",
                newPassword: "",
                confirmPassword: "",
              })
            }
          >
            Cancel
          </Button>
          <Button type="submit" variant="primary">
            Reset
          </Button>
        </div>
      </form>
    </>
  );
};

export default ResetPasswordCard;
